import { Reveal, CTAButton } from "@/components/okaia/Reveal";
import { TIDYCAL_URL, TALLY_URL } from "@/config/links";

export const FinalCTA = () => (
  <section data-testid="section-final-cta" className="bg-[#0B2215] py-20 md:py-28">
    <div className="mx-auto max-w-[1400px] px-6 text-left md:px-12">
      <Reveal>
        <h2 className="max-w-4xl font-serif-display text-4xl leading-[1.1] tracking-tight text-[#F9F8F6] md:text-5xl lg:text-6xl">
          Vous n'avez pas besoin de tout savoir pour commencer à avancer.
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-8 max-w-2xl text-base font-light leading-relaxed text-[#A3B1AA] md:text-lg">
          La première étape consiste simplement à clarifier votre situation. Choisissez le
          parcours qui correspond à votre besoin.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-12 grid gap-10 sm:grid-cols-2 lg:max-w-4xl">
          <div>
            <p className="okaia-overline mb-4 text-[#C8A97E]">Faire le point sur mon activité</p>
            <CTAButton label="Réserver mon diagnostic — 49 €" testId="final-cta" href={TIDYCAL_URL} />
            <p className="mt-4 text-xs font-medium uppercase tracking-[0.18em] text-[#A3B1AA]">
              30 minutes • Visioconférence • Synthèse écrite et cinq actions
            </p>
          </div>
          <div>
            <p className="okaia-overline mb-4 text-[#C8A97E]">Trouver une formation adaptée</p>
            <CTAButton label="Trouver ma formation" testId="final-cta-formation" variant="outline" href={TALLY_URL} />
            <p className="mt-4 text-xs font-medium uppercase tracking-[0.18em] text-[#A3B1AA]">
              Orientation gratuite • Aucun diagnostic payant obligatoire
            </p>
          </div>
        </div>
        <p className="mt-12 font-serif-display text-sm italic text-[#C8A97E]">
          Voir clair. Décider juste. Développer durablement.
        </p>
      </Reveal>
    </div>
  </section>
);
